module.exports = __webpack_public_path__ + "static/img/1.ec2c341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Accidentes-personales/1.png
// module id = o7Mh
// module chunks = 0